<template>
  <div class="login-page">
    <nav
      class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent"
    >
      <div class="container">
        <div class="navbar-wrapper">
          <div class="navbar-toggle">
            <button type="button" class="navbar-toggler">
              <span class="navbar-toggler-bar bar1"></span>
              <span class="navbar-toggler-bar bar2"></span>
              <span class="navbar-toggler-bar bar3"></span>
            </button>
          </div>
          <a class="navbar-brand" href="#pablo">Modern-Expo Go Go</a>
        </div>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navigation"
          aria-controls="navigation-index"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
        </button>
        <div
          class="collapse navbar-collapse justify-content-end"
          id="navigation"
        >
          <ul class="navbar-nav">
            <!-- <li class="nav-item ">
              <a href="#" class="nav-link">
                <i class="nc-icon nc-book-bookmark"></i> Register
              </a>
            </li> -->
            <li class="nav-item active">
              <a href="/" class="nav-link">
                <i class="nc-icon nc-tap-01"></i> Login
              </a>
            </li>
            <!-- <li class="nav-item ">
              <a href="#" class="nav-link">
                <i class="nc-icon nc-key-25"></i> Lock
              </a>
            </li> -->
          </ul>
        </div>
      </div>
    </nav>
    <!-- End Navbar -->
    <div class="wrapper wrapper-full-page">
      <div class="full-page section-image" filter-color="black">
        <div
          class="full-page-background"
          :style="{
            backgroundImage:
              'url(' + require('./../assets/img/bg/modern.jpg') + ')',
          }"
        />
        <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form class="form" method="" action="">
                <div class="card card-login">
                  <div class="card-header">
                    <div class="card-header">
                      <h3 class="header text-center">Login</h3>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="nc-icon nc-single-02"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Login"
                        v-model="dataAuthorization.user"
                        v-on:keyup.enter="Login()"
                      />
                    </div>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="nc-icon nc-key-25"></i>
                        </span>
                      </div>
                      <input
                        type="password"
                        placeholder="Password"
                        class="form-control"
                        v-model="dataAuthorization.password"
                        v-on:keyup.enter="Login()"
                      />
                    </div>
                    <br />
                  </div>
                  <div class="card-footer">
                    <a
                      href="#pablo"
                      class="btn btn-warning btn-round btn-block mb-3"
                      @click="Login()"
                      >Get Started</a
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <footer class="footer footer-black footer-white">
          <div class="container-fluid">
            <div class="row">
              <nav class="footer-nav">
                <ul>
                  <li>
                    <a href="https://modern-expo.eu/" target="_blank"
                      >Modern-Expo site</a
                    >
                  </li>
                  <li>
                    <a href="https://modern-expo.eu/uk/category" target="_blank"
                      >Products</a
                    >
                  </li>
                  <!--<li>
                    <a href="https://www.modern-expo.com/uk/policy" target="_blank">Policy</a>
                  </li>-->
                </ul>
              </nav>
              <div class="credits ml-auto">
                <span class="copyright">
                  © made with <i class="fa fa-heart heart"></i> by Modern-Expo
                  IT TEAM
                </span>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <div v-show="loading">
      <div
        class="loader-overlay"
        id="point-loader"
        style="position: fixed !important"
      >
        <div
          style="
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <atom-spinner
            :animation-duration="1000"
            :size="160"
            :color="'#ff1d5e'"
          />
        </div>
      </div>
    </div>
    <notifications group="error" classes="alert alert-danger" />
    <notifications group="info" classes="alert alert-info" />
    <notifications group="success" classes="alert alert-success" />
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
export default {
  name: "Login",
  components: {
    AtomSpinner,
  },
  data() {
    return {
      dataAuthorization: {
        user: "",
        password: "",
        ip: "",
      },
      loading: false,
    };
  },
  methods: {
    Login() {
      let errorF = "";
      fetch("https://api.ipify.org?format=json")
        .then((respons) => respons.json())
        .then(({ ip }) => {
          this.dataAuthorization.ip = ip;
          console.log(this.dataAuthorization.ip);

          if (this.dataAuthorization.password.length > 0) {
            this.loading = true;
            axios
              .post("/drawing/loginDraw", {
                dataAuthorization: this.dataAuthorization,
              })
              .then((res) => {
                if (res.data.cod != undefined) {
                  this.loading = false;
                  this.showNotify("error", "Error auth", res.data.error);
                } else {
                  localStorage.setItem(
                    "user",
                    JSON.stringify(res.data.username)
                  );
                  localStorage.setItem("user-token", res.data.session);
                  localStorage.setItem("role", res.data.roles);
                  localStorage.setItem("name", res.data.name);
                  if (res.data.image != null) {
                    localStorage.setItem(
                      "image",
                      "data:image/jpg;base64," + res.data.image
                    );
                    this.$store.commit(
                      "setProfileImage",
                      "data:image/jpg;base64," + res.data.image
                    );
                  }
                  localStorage.setItem("ip", this.dataAuthorization.ip);
                  if (localStorage.getItem("user-token") != null) {
                    this.$emit("loggedIn");
                    if (this.$route.params.nextUrl != null) {
                      this.loading = false;
                      this.$router.push(this.$route.params.nextUrl);
                    } else {
                      this.loading = false;
                      this.$router.push("dashboard");
                    }
                  }
                }
              })
              .catch((e) => {
                console.log(e);
                this.loading = false;
                //this.$noty.error("Authorization error.");
                this.showNotify("error", "Error", e);
              });
          }
        })
        .catch((error) => {
          console.log(error);
          errorF = error;
        });

      if (errorF != "") {
        this.showNotify(
          "error",
          "Error",
          "Access to IP address identification is not allowed: " + errorF
        );
      }
    },
    showNotify(group, title, messages) {
      this.$notify({
        group: group,
        title: title,
        text: messages,
      });
    },
  },
  mounted() {
    localStorage.removeItem("user-token");
    localStorage.removeItem("ip");
    localStorage.removeItem("name");
    localStorage.removeItem("role");
    localStorage.removeItem("user");
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue